// @ts-nocheck
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * roles: allowed roles (super_admin always allowed)
 * module: system module key — if disabled by super admin, non-super users redirected
 */
export default function ProtectedRoute({ children, roles, module: moduleKey }) {
    const { user, loading, moduleOn } = useAuth();

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center min-vh-100">
                <div className="spinner-border text-success" />
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    if (roles && roles.length) {
        const ok = user.role === 'super_admin' || roles.includes(user.role);
        if (!ok) {
            return <Navigate to={user.role === 'customer' ? '/portal' : '/dashboard'} replace />;
        }
    }

    if (moduleKey && !moduleOn(moduleKey)) {
        return <Navigate to={user.role === 'customer' ? '/portal' : '/dashboard'} replace />;
    }

    return children;
}
